// src/page/InvalidRegionAccess.jsx
import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { store } from "../store/index";
import useLogout from "../hooks/useLogOut.js";

const InvalidRegionAccess = () => {
  const [isOpen, setIsOpen] = useState(false);
  const user_region = store.getState()?.user?.user_region;
  // const history = useHistory();
  const navigate = useNavigate();
  const { logout } = useLogout();

  useEffect(() => {
    const handleShowPopup = () => {
      setIsOpen(true);
    };
    window.addEventListener("showRegionPopup", handleShowPopup);
    return () => window.removeEventListener("showRegionPopup", handleShowPopup);
  }, []);

  const handleUpgrade = () => {
    setIsOpen(false);
    navigate("/admin/plans");
  };

  const handleLogout = () => {
    setIsOpen(false);
    logout();
  };

  return (
    <>
    {isOpen && <div className="modal-backdrop-blur" />}
    <Modal
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      className="region-access-modal"
      centered
    >
      <ModalBody>
        <h4>Region Access Restricted</h4>
        <p>
          Your subscription is only valid for use within {user_region}. It looks
          like you are trying to access the website from outside this region.
        </p>
        <p>
          If you believe this is a mistake, please contact support +61
          426230061.
          <br />
          To upgrade your plan and unlock global access.
        </p>
        <div className="region-access-buttons">
          <Button color="primary" onClick={handleUpgrade}>
            Upgrade Plan
          </Button>
          <span>or</span>
          <Button onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </ModalBody>
    </Modal>
    </>
  );
};

export default InvalidRegionAccess;
